<template>
    <div class="c-baner" v-if="brand">
        <img :src="brand.baner" :alt="brand.name">
        <div class="c-baner__headline text-center">
            <h1>
                Chcesz sprawdzić osobiście możliwości samochodu?
                <br>
                Wypełnij krótki formularz, żebyśmy poznali Twoje oczekiwania.
            </h1>
        </div>
    </div>
</template>
<script>
export default {
    props:['brand']
}
</script>
<style lang="scss">
    .c-baner{
        img{
            max-width: 100%;
            height: auto;
        }
        position: relative;
        &__headline{
            @media(min-width: 780px){
                position: absolute;
                bottom: 0;
                z-index: 666;
                left: 0;
                right: 0;
            }
            background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 95%);
            padding: 2rem 1rem 1rem 1rem;
            h1{
                line-height: 1.7rem;
                font-size: 1.5rem;
                @media(min-width: 780px){
                    font-size: 2.5rem;
                    line-height: 2.8rem;
                }
            }
        }
    }
</style>